module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r9n7r4n-013abbf57369788677a0fc34dad779d8.svg";